import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 导入axios
import axios from "axios"


// 引入第三方图标库
import '@/assets/fonticon/iconfont.css'

// 引入element-plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'


//引入swiper样式
import "swiper/swiper-bundle.css"


//引入公共样式
import '@/assets/css/public.css'

const fixElTableErr = (table) => {
    const oldResizeListener = table.methods.resizeListener;
    table.methods.resizeListener = function () {
        window.requestAnimationFrame(oldResizeListener.bind(this));
    };
};

const app = createApp(App)
app.use(ElementPlus)
app.use(store).use(router).mount('#app')
const apiUrl = 'http://test.yf.hzcxy.cn/api';